/* 30/09 perf : ce fichier est chargé en « async » (il ne bloque plus l'affichage de la page).
   Il attend son repère #almk-menumob (posé juste avant la balise script) pour démarrer exactement au même moment qu'avant.
   Sans repère sur la page : il démarre à la fin du chargement. */
(function almBoot(){
  if (document.readyState === 'loading' && !document.getElementById('almk-menumob')) { setTimeout(almBoot, 20); return; }

(function(){
  if (window.__almmMenu) return; window.__almmMenu = 1;
  if (/[?&]oldmenu=1/.test(location.search)) return;

  var html = document.documentElement;
  var root = document.getElementById('almmRoot');
  if (!root) return;
  html.classList.add('almm-ready');

  var MAX = 1024;
  function isMobile(){ return window.innerWidth <= MAX; }

  /* ---- verrous de defilement poses par le theme : on les nettoie ---- */
  var LOCK_CLASSES = ['no-scroll','noscroll','overflow-hidden','scroll-lock','scroll-locked',
    'is-locked','locked','menu-open','drawer-open','ntyd-lock','ntyd-open','mz-lock','mz-no-scroll','body--locked'];
  var LOCK_PROPS = ['overflow','overflow-y','position','top','left','right','width','height'];

  function unlockScroll(){
    var body = document.body;
    var savedTop = body.style.top;
    [html, body].forEach(function(el){
      LOCK_CLASSES.forEach(function(c){ el.classList.remove(c); });
      LOCK_PROPS.forEach(function(p){ el.style.removeProperty(p); });
    });
    /* si le theme avait fige la page en position:fixed avec top:-Npx, on rend le scroll */
    if (savedTop && savedTop.charAt(0) === '-') {
      var y = Math.abs(parseInt(savedTop, 10)) || 0;
      window.scrollTo(0, y);
    }
  }

  function closeOld(){
    ['ntydDrawer','ntydOverlay','mzMobile','mzOverlay'].forEach(function(id){
      var el = document.getElementById(id);
      if (el) el.classList.remove('is-open','open','active');
    });
  }

  function open(){
    closeOld();
    /* 12/09/2026 perf : les visuels du menu ne se telechargent qu'a l'ouverture */
    try { root.querySelectorAll('img[data-src]').forEach(function(im){ im.src = im.dataset.src; im.removeAttribute('data-src'); }); } catch(e){}
    root.classList.add('almm-open');
    root.setAttribute('aria-hidden','false');
    html.classList.add('almm-lock');
  }
  function close(){
    root.classList.remove('almm-open');
    root.setAttribute('aria-hidden','true');
    html.classList.remove('almm-lock');
    closeOld();
    unlockScroll();
    /* certains scripts du theme reposent leur verrou juste apres : on repasse */
    setTimeout(unlockScroll, 350);
  }
  window.almmOpen = open; window.almmClose = close;
  /* 12/09/2026 perf : sur bonne connexion, les visuels du menu sont recuperes 3 s apres le chargement (menu instantane a l'ouverture) */
  try { window.addEventListener('load', function(){ setTimeout(function(){ var c = navigator.connection || {}; if (c.saveData || /2g|3g/.test(c.effectiveType || '')) return; root.querySelectorAll('img[data-src]').forEach(function(im){ im.src = im.dataset.src; im.removeAttribute('data-src'); }); }, 3000); }); } catch(e){}

  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('#mzBurger, .mz-burger, [data-ntyd-open], .ntyd-open');
    if (b) {
      if (!isMobile()) return;
      e.preventDefault(); e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open();
      return;
    }
    if (t.closest('[data-almm-close]')) { e.preventDefault(); close(); return; }
    var lg = t.closest('[data-almm-lang]');
    if (lg) {
      e.preventDefault();
      var code = lg.getAttribute('data-almm-lang');
      var target = [].slice.call(document.querySelectorAll('.mz-ann-lang-item, .ntyg-lang__item'))
        .filter(function(x){ return x.textContent.trim().toUpperCase() === code; })[0];
      if (target) target.click();
      return;
    }
    if (root.contains(t) && t.closest('a[href]')) close();
  }, true);

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && root.classList.contains('almm-open')) close();
  });

  window.addEventListener('resize', function(){
    if (!isMobile() && root.classList.contains('almm-open')) close();
  });

  /* filet de securite : si la page se retrouve figee alors qu'aucun panneau
     n'est ouvert, on libere le defilement */
  setInterval(function(){
    if (root.classList.contains('almm-open')) return;
    var drawerOpen = document.querySelector('#mzc-drawer.active, #ntydDrawer.is-open, .mz-mobile-menu.is-open');
    if (drawerOpen) return;
    var b = document.body;
    var cs = window.getComputedStyle(b);
    if (cs.overflow === 'hidden' || cs.position === 'fixed') unlockScroll();
  }, 1200);

  var old = document.getElementById('ntydDrawer');
  if (old && window.MutationObserver) {
    new MutationObserver(function(){
      if (isMobile() && old.classList.contains('is-open')) { closeOld(); open(); }
    }).observe(old, {attributes:true, attributeFilter:['class']});
  }
})();

})();
